$(document).ready(function () {
  // $("#variant-list li span.add-to-cart-variant").on("click", function () {
  //   var variantId = $(this).data("variant-id");
  //   console.log(variantId);
  //   $.ajax({
  //     type: "POST",
  //     url: "/cart/add.js",
  //     data: {
  //       id: variantId,
  //       quantity: 1,
  //     },
  //     dataType: "json",
  //     success: function (data) {
  //       window.location.href = "/cart";
  //     },
  //   });
  // });

  $(document).on(
    "click",
    "li.menu-link.has-submenu a.menu-in-anchor",
    function (e) {
      e.preventDefault();
      $(this)
        .parents(".menu-link")
        .find(".custom-mobile-dropdown")
        .slideToggle();
      $(this).parents(".menu-link").toggleClass("menu-link-active");
    }
  );
  //$(".custom-mobile-dropdown li.menu-link ul.menu.dropdown-child").slideUp();
  $(document).on(
    "click",
    ".custom-mobile-dropdown  a.inner-child.has-mob-inner-child",
    function (e) {
      e.preventDefault();
      $(this)
        .parents("li.menu-link.fourth-lvl-menu")
        .find("ul.menu.dropdown-child")
        .slideToggle();
      $(this)
        .parents("li.menu-link.fourth-lvl-menu")
        .toggleClass("menu-inner-link-active");
    }
  );

  $(".collection-slider-in").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".collection-slider-in-2").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $("#variant-list li").hover(function () {
    $(this).parents("#variant-list").find("li").removeClass("active");
    $(this).addClass("active");
    var qty = parseInt($(this).find("span").data("variant-qty"));
    var available = $(this).find("span").data("vaiant-available");
    if (available) {
      if (qty <= 0) {
        $(this).parents(".product-item").find(".badge-in-pre-order").html("PRE ORDER").addClass("active_badge");
        // .removeClass("in-stock")
        // .removeClass("sold-out")
        // .addClass("pre-order")
        // .html("PRE ORDER");
      } else {
        $(this).parents(".product-item").find(".badge-in-pre-order").html("IN STOCK").addClass("active_badge");
        // .removeClass("pre-order")
        // .removeClass("sold-out")
        // .addClass("in-stock")
        // .html("IN STOCK");
      }
    } else {
      $(this).parents(".product-item").find(".badge-in-pre-order").html("SOLD OUT").addClass("active_badge");
      // .removeClass("pre-order")
      // .removeClass("in-stock")
      // .addClass("sold-out")
      // .html("SOLD OUT");
    }
  });

  if ($(window).width < 767){
    $(".product-item__image[data-product-image]").hover(
      function () {
        var variant_list_height = $(this).find("#variant-list").height();
        if (variant_list_height == undefined) {
          var variant_list_height = 40;
        }
        console.log(variant_list_height);
        $(this)
          .find(".sale-box, .preorder-box, .badge-box")
          .attr(
            "style",
            "bottom: " + (variant_list_height + 15) + "px !important;"
          );
        $(this)
          .find(".badge-box.badge-box-2")
          .attr(
            "style",
            "bottom: " + (variant_list_height + 40) + "px !important;"
          );
      },
      function () {
        $(this)
          .find(".sale-box, .preorder-box, .badge-box")
          .attr("style", "bottom: 5px !important;");
        $(this)
          .find(".badge-box.badge-box-2")
          .attr("style", "bottom: 30px !important;");
      }
    );
  }

  setInterval(function () {
    $('.radio__legend__option-name').each(function(){
      if($(this).text() == "Color"){
        $(this).text("Colour");
      }
    });
    $('.product-item__swatches__count').each(function(){
      $(this).find("span").text($(this).find("span").text().replace("colors", "Colours"));
    });
  }, 1000);

  $(".menu-tab-buttons").on("click", function () {
    $(".collection-slider-in").slick("refresh");
    $(".collection-slider-in-2").slick("refresh");
  });
});
document.addEventListener("DOMContentLoaded", function () {
  if (typeof Shopify !== 'undefined' && Shopify.checkout && Shopify.checkout.note_attributes) {
    const unwantedKeys = [
      "session_id",
      "visitor_id",
      "_fbp",
      "_fbc",
      "_ttp",
      "_ga"
    ];

    unwantedKeys.forEach(function (key) {
      if (Shopify.checkout.note_attributes.hasOwnProperty(key)) {
        delete Shopify.checkout.note_attributes[key];
      }
    });
  }
});

